import type { GetReleaseKitResponse, SerializedKitAsset } from '../fymAPI.types';
import type { SerializedReel } from '../../../modules/music24/promote/types';

/**
 * Writes the rows that "Make it" made into the cached release kit answer of the song, so the
 * Studio card and the song page say "1 making" at once, before the read that the mutation starts
 * comes back. A new version is the newest row of its theme and variant, so it takes the place of
 * the current one, as the server's `currentKitAssets` does.
 */
export function addMadeKitAssets(release: GetReleaseKitResponse, created: SerializedKitAsset[]): void {
  created.forEach((asset) => {
    const index = release.assets.findIndex(
      (known) => known.themeId === asset.themeId && known.variant === asset.variant
    );
    if (index === -1) {
      release.assets.push(asset);
    } else {
      release.assets[index] = asset;
    }
  });
}

/** Puts a new reel first in the cached release kit answer (the reels are newest first). */
export function addMadeReel(release: GetReleaseKitResponse, reel: SerializedReel): void {
  if (!release.reels.some((known) => known.uuid === reel.uuid)) {
    release.reels.unshift(reel);
  }
}
